import differenceInMonths from 'date-fns/differenceInMonths';
import isValidDate from 'date-fns/isValid';
import parseDate from 'date-fns/parse';
import * as yup from 'yup';

const nameRegex = /^[ a-zA-Z0-9._-]*$/g;
const emailRegex = /^(([^<>()[\]\\.,;:\s@"']+(\.[^<>()[\]\\.,;:\s@"']+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

export const schema = yup.object().shape({
  cardnumber: yup
    .string()
    .transform(value => value.replaceAll(' ', ''))
    .min(16, 'Your card should have 16 digits')
    .required('Please enter your card information'),
  expdate: yup
    .string()
    .length(5, 'Please enter a valid expiration date (MM/YY)')
    .matches(
      /([0-9]{2})\/([0-9]{2})/,
      'Please enter a valid expiration date (MM/YY)'
    )
    .required('Please enter your expiration date (MM/YY)')
    .test(
      'invalid date',
      'Please enter a valid expiration date (MM/YY)',
      value => {
        const parsedDate = parseDate(value, 'MM/yy', new Date());
        return isValidDate(parsedDate);
      }
    )
    .test('expired', 'Your card expired. Please add a new one', value => {
      const parsedDate = parseDate(value, 'MM/yy', new Date());
      return differenceInMonths(new Date(), parsedDate) <= 0;
    }),
  csc: yup
    .string()
    .transform(value => value.substr(0, 3))
    .length(3, 'Please enter a valid CVV')
    .required('Please enter your CVV'),
  postalCode: yup
    .string()
    .transform(value => value.substr(0, 5))
    .length(5, 'Please enter a valid ZIP code')
    .required('Please enter your ZIP code'),
  terms: yup.boolean().oneOf([true]),
  firstName: yup
    .string()
    .min(2, 'Your first name must be at least ${min} characters long')
    .matches(nameRegex, 'Your first name cannot contain special characters')
    .required('Please enter your first name'),
  lastName: yup
    .string()
    .min(2, 'Your last name must be at least ${min} characters long')
    .matches(nameRegex, 'Your last name cannot contain special characters')
    .required('Please enter your last name'),
  email: yup
    .string()
    .matches(emailRegex, 'Please correct your email address')
    .required('Please enter your email'),
});

export const mobileClaimSchema = schema.omit(['email']);
